export const INK_COLOR = 'rgba(0, 16, 163, 1)';
